/*
 * Copyright Mimic Networks, Inc. 2025.
 */

import BurgerMenu from '@/primitives/Icons/Menu.svg?react';
import './MainLayoutSiderToggle.css';

export type MainLayoutSiderToggleProps = {
  toggleSidebar: () => void;
};

export function MainLayoutSiderToggle({ toggleSidebar }: MainLayoutSiderToggleProps) {
  return (
    <button data-testid="burger" className="main-layout-sider-toggle" type="button" onClick={toggleSidebar}>
      <BurgerMenu fontSize="2em" color="#A4A2A0" />
    </button>
  );
}
